export default __webpack_public_path__ + "static/media/sprite.251426c8.svg";